import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Check, Pencil, Sparkles } from "lucide-react";

export const DescriptionEditor = ({ suggestedDescription, onConfirm }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [description, setDescription] = useState(suggestedDescription);

  const handleConfirm = () => {
    onConfirm(description);
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Enter" && !isEditing) {
        e.preventDefault();
        handleConfirm();
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [isEditing, description]);

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="gm-desc-editor"
    >
      {isEditing ? (
        <textarea
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          className="gm-desc-textarea"
          placeholder="Enter market description..."
        />
      ) : (
        <div onClick={() => setIsEditing(true)} className="gm-desc-display">
          <p className="gm-desc-text">{description}</p>
        </div>
      )}

      <div className="gm-desc-actions">
        {!isEditing && (
          <button onClick={() => setIsEditing(true)} className="gm-desc-btn">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
            >
              <path
                d="M9.43493 1.3039C9.76645 0.972379 10.2161 0.786133 10.6849 0.786133C11.1538 0.786133 11.6034 0.972379 11.9349 1.3039C12.2665 1.63542 12.4527 2.08506 12.4527 2.5539C12.4527 3.02274 12.2665 3.47238 11.9349 3.8039L4.4241 11.3156C4.22622 11.5133 3.98177 11.658 3.71327 11.7364L1.3191 12.4364C1.24739 12.4573 1.17138 12.4586 1.09902 12.44C1.02667 12.4215 0.960622 12.3838 0.907805 12.331C0.854988 12.2782 0.817341 12.2122 0.798803 12.1398C0.780265 12.0675 0.781519 11.9914 0.802433 11.9197L1.50243 9.52557C1.58121 9.25728 1.72621 9.01312 1.9241 8.81557L9.43493 1.3039Z"
                stroke="#DAD9D9"
                stroke-width="1.57143"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            Edit
          </button>
        )}
        <button onClick={handleConfirm} className="gm-desc-btn">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
          >
            <path
              d="M13.3334 4L6.00002 11.3333L2.66669 8"
              stroke="#E6FF00"
              stroke-width="1.33333"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          {isEditing ? "Save" : "Confirm"}
        </button>
        {isEditing && (
          <button
            onClick={() => {
              setDescription(suggestedDescription);
              setIsEditing(false);
            }}
            className="gm-desc-btn"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                d="M12 4L4 12"
                stroke="#DAD9D9"
                stroke-width="1.33333"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M4 4L12 12"
                stroke="#DAD9D9"
                stroke-width="1.33333"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            Cancel
          </button>
        )}
      </div>
    </motion.div>
  );
};
